// Mirrors `entities/src/oidc/constants.ts`, so browser code does not import the
// entities data layer.
export const OIDC_REFRESH_PATH = '/auth/oidc/refresh'
export const OIDC_LOGOUT_PATH = '/auth/oidc/logout'
export const OIDC_AUTHORIZE_PATH = '/auth/oidc/authorize'
export const OIDC_IMPERSONATE_STOP_PATH = '/auth/oidc/impersonate/stop'

// Env-stamped for the current environment (dev/local/bibe) by bibe `getUrl` at
// call time, which a build-time value cannot do for bibe hostnames.
export const CALLBACKS_PRODUCTION_URL = 'https://callbacks.buffer.com'

export const REFRESH_IMPERSONATION_ERROR = 'no_refresh_token_impersonation'
export const REFRESH_NO_SESSION_ERROR = 'no_refresh_token'
export const REFRESH_UNAVAILABLE_ERROR = 'refresh_unavailable'
